// Pure helpers для ProfileTab (Mini-sprint 6-profile, Stage 4 §1).
// Source: docs/specs/sprint-6-profile/stage-4-frontend.md §1.
//
// Все три helper'а — pure, testable без DOM/React.

import type { ProfileMeSurvey } from '@/api/types';

// ─── initialFromName ───────────────────────────────────────────────────────

export function initialFromName(name: string | null | undefined): string {
  if (!name) return '?';
  const trimmed = name.trim();
  if (trimmed.length === 0) return '?';
  // Array.from — корректно для unicode/surrogate pairs (на случай emoji-имён).
  const first = Array.from(trimmed)[0];
  return first ? first.toUpperCase() : '?';
}

// ─── formatUploadsCounter ──────────────────────────────────────────────────
// R1: принимает totals (числа из meta.total двух запросов), не массив.
// Backend paginated, источник — meta.total, не data.length.

const FILES_FORMS = ['файл', 'файла', 'файлов'] as const;
const RECOGNIZED_FORMS = ['распознан', 'распознаны', 'распознаны'] as const;

function ruPlural(n: number, forms: readonly [string, string, string]): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return forms[0];
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return forms[1];
  return forms[2];
}

export function formatUploadsCounter(total: number, recognized: number): string {
  if (total === 0) return '0 файлов';
  const totalStr = `${total} ${ruPlural(total, FILES_FORMS)}`;
  if (recognized === 0) return totalStr;
  const recStr = `${recognized} ${ruPlural(recognized, RECOGNIZED_FORMS)}`;
  return `${totalStr} · ${recStr}`;
}

// ─── formatSurveyStatus ────────────────────────────────────────────────────
// Defensive helper. В UI достижим только «completed»-state — /profile обёрнут
// в RequireSurveyCompleted guard'ом. Остальные ветки — для защиты от регрессии
// routing'а и для тестов.

const MONTHS_GENITIVE = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
] as const;

export function formatSurveyStatus(survey: ProfileMeSurvey): string {
  if (!survey.exists) return 'Не заполнена';
  if (!survey.completed) return 'Заполнена частично · продолжить';

  const d = new Date(survey.updated_at);
  const day = d.getUTCDate();
  const month = MONTHS_GENITIVE[d.getUTCMonth()];
  return `Заполнена · обновлено ${day} ${month}`;
}
